module.exports = __webpack_public_path__ + "static/img/016.0a7758c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/016.png
// module id = ZizZ
// module chunks = 0